import API from "../../../utils/helpers/API.helpers";

const KodeEtikService = {
  async getKodeEtikByMKSpesialID(mKSpesialId) {
    return await API.get({ endpoint: `/kode-etik/?mk_spesial=${mKSpesialId}` });
  },
  async getKodeEtikByMKSesialAndMahasiswaId(mKSpesialId, mahasiswaId) {
    return await API.get({
      endpoint: `/kode-etik/?mk_spesial=${mKSpesialId}&mahasiswa=${mahasiswaId}`,
    });
  },
  async putKodeEtik(mKSpesialId, is_agree) {
    return await API.put({
      endpoint: `/kode-etik/`,
      data: { mk_spesial: mKSpesialId, is_agree: is_agree },
    });
  },
};

export default KodeEtikService;
